import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Button, Grid } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import { useForm } from '../../../../hooks/useForm';

const useStyles = makeStyles({
  botonera: {
    padding: 25,
  },
});

export const FormIngresoInformesModificar = (props) => {
  const FormInicial = {
    protocolo: '',
    idEfector: 0,
    nombreProfesional: '',
    nombreInforme: '',
  };

  const classes = useStyles();
  const { Informes } = props;
  const [formValues, handleInputChange] = useForm(
    Informes ? Informes : FormInicial,
  );

  const handleSave = (e) => {
    e.preventDefault();
    const datos = {
      id: formValues.id,
      protocolo: formValues.protocolo,
      nombre: formValues.nombreInforme,
    };
    props.handleSave(datos);
    props.cerrarModal();
  };

  return (
    <ValidatorForm onSubmit={handleSave}>
      <Grid container style={{ padding: 25 }}>
        <Grid item xs={12} md={6}>
          <TextValidator
            margin="normal"
            label="Nombre Profesional"
            name="nombreProfesional"
            autoComplete="off"
            disabled={true}
            value={formValues.nombreProfesional}
            onChange={handleInputChange}
            fullWidth
            style={{ paddingRight: '0.5rem' }}
            validators={['required']}
            errorMessages={['No puede estar vacio']}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextValidator
            margin="normal"
            label="Nombre Informe"
            name="nombreInforme"
            autoComplete="off"
            value={formValues.nombreInforme}
            onChange={handleInputChange}
            fullWidth
            style={{ paddingRight: '0.5rem' }}
            validators={['required']}
            errorMessages={['No puede estar vacio']}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextValidator
            fullWidth
            variant="outlined"
            multiline
            rows={12}
            label="Protocolo"
            name="protocolo"
            value={formValues.protocolo}
            onChange={handleInputChange}
            style={{ paddingRight: '0.5rem' }}
            validators={['required']}
            errorMessages={['La descripción es requerida']}
          />
        </Grid>
        <Grid container className={classes.botonera}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="flex-end"
              alignItems="center"
            >
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<CancelIcon />}
                onClick={props.cerrarModal}
              >
                CANCELAR
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<SaveIcon />}
                type="submit"
                style={{ marginLeft: '0.5rem' }}
              >
                GUARDAR
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ValidatorForm>
  );
};
